export default __webpack_public_path__ + "f34767478d11f9799477db6a7f29fe91.png";